module.exports = __webpack_public_path__ + "img/e179338.png";